import { useClientAppConfig } from "../../../hooks/gym/useClientAppConfig";
import { useModuleEnabled } from "../../../hooks/gym/useModuleEnabled";
import { useCurrentGym } from "../../../hooks/gym/useCurrentGym";
import { ToggleSwitch } from "../../common/ui/toggleSwitch";

export const ClientAppConfigSection = () => {
  const clientAppEnabled = useModuleEnabled("clientApp");
  const { isLoading: gymLoading } = useCurrentGym();
  const { autoInviteOnCreate, isLoading, setAutoInviteOnCreate, isUpdating } =
    useClientAppConfig();
  // Sin esto el switch arranca en off mientras cargan y anima hacia on.
  const loading = gymLoading || isLoading;

  return (
    <div className="flex flex-col gap-4">
      <div>
        <h4 className="text-size-sm font-semibold text-global-primary">
          App del cliente
        </h4>
        <p className="text-size-2xs text-global-tertiary mt-1">
          Al registrar un cliente con correo, le enviamos su contraseña temporal
          y los links para descargar la app.
        </p>
      </div>

      {loading ? (
        <div className="h-[50px] rounded-lg border border-global-secondary bg-global-overlay-secondary animate-pulse" />
      ) : (
        <>
          <ToggleSwitch
            id="auto-invite-on-create"
            label="Enviar invitación a la app al crear un cliente"
            checked={clientAppEnabled && autoInviteOnCreate}
            onToggle={setAutoInviteOnCreate}
            disabled={!clientAppEnabled || isUpdating}
            className={clientAppEnabled ? "" : "opacity-60"}
          />

          {!clientAppEnabled && (
            <p className="text-size-2xs text-global-muted">
              Disponible cuando el módulo App del cliente esté activo. Contacta
              a soporte para activarlo.
            </p>
          )}
        </>
      )}
    </div>
  );
};
